import type { volcengineModelConfig, StatusMapping } from './types';
import { seedanceConfigs } from './configs/seedance';
import { seedance2BeijingConfigs } from './configs/seedance2_beijing';
import { seedance1Configs } from './configs/seedance1';

// create and poll api paths and status mapping are same for all models

/**
 * volcengine API 路径配置（所有模型统一使用）
 */
export const volcengineApiPaths = {
    /** 创建任务 API 路径 */
    createTask: '/api/v3/contents/generations/tasks',
    /** 轮询任务 API 路径 */
    pollTask: '/api/v3/contents/generations/tasks',
};

/**
 * volcengine 状态映射配置（所有模型统一使用）
 */
export const volcengineStatusMapping: StatusMapping = {
    /** 任务 ID 字段路径 */
    taskIdPath: 'id',
    /** 状态字段路径 */
    statePath: 'status',
    /** 成功状态值 */
    success: ['succeeded'],
    /** 失败状态值 */
    failed: ['failed', 'cancelled', 'expired'],
    /** 处理中状态值 */
    processing: ['queued', 'running'],
    /** 视频 URL 字段路径 */
    videoUrlPath: 'content.video_url',
    /** 错误信息字段路径 */
    errorPath: 'error.message',
};

/**
 * 模型配置映射
 */
export const volcengineModelConfigs: Record<string, volcengineModelConfig> = {
    ...seedanceConfigs,
    ...seedance2BeijingConfigs,
    ...seedance1Configs,
};
